import { defineSlotRecipe } from '@chakra-ui/react';

/**
 * SegmentGroup Component Theme
 *
 * This defines the styling for the SegmentGroup component using Chakra's slot recipe pattern.
 * Slot recipes allow styling multiple parts of a component that work together.
 *
 * Slots:
 * - root: The outer container
 * - item: Individual segment items
 * - itemText: Text content within items
 * - indicator: The active state indicator
 */
export const segmentGroupSlotRecipe = defineSlotRecipe({
  className: 'segment-group',
  slots: ['root', 'item', 'itemText', 'indicator'],
  base: {
    root: {
      background: 'menuBackground',
      borderRadius: '6px',
    },
    item: {
      justifyContent: 'center',
      color: 'buttonText',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      position: 'relative',
      // Vertical separator lines between items (using _before pseudo-element)
      _before: {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '1px',
        height: '60%',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        zIndex: 0,
      },
      // Hide separator for first item
      _first: {
        _before: {
          display: 'none',
        },
      },
      // Checked state
      _checked: {
        color: 'buttonText',
        _before: {
          opacity: 0,
        },
      },
      _hover: {
        '& i': {
          color: 'warningAccent',
        },
      },
    },
    itemText: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    indicator: {
      background: 'primary',
    },
  },
  variants: {
    variant: {
      default: {},
      fullWidth: {
        root: {
          width: '100%',
          overflowX: 'auto',
          overflowY: 'hidden',
        },
        item: {
          flex: '1 1 0',
          minWidth: 0,
          padding: '8px 4px',
        },
        itemText: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});